export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8900.94cce7ba.jpg";